<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="p_2"></a> First Mariner Books edition 2014</p>
<p class="timebreak"> <br/></p>
<p class="center">Copyright © 2013 by The Gronkowski Family with Jeff Schober</p>
<p class="timebreak"> <br/></p>
<p class="center">All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data is available. </em></p>
<p class="center">Gronkowski family.<br/>
Growing up Gronk : a family’s story of raising champions / Gronkowski family with Jeff Schober.<br/>
pages cm<br/>
<span style="font-size: smaller">ISBN</span> 978-0-544-12668-8 (hardback) <span style="font-size: smaller">ISBN</span> 978-0-544-33458-8 (pbk.)<br/>
1. Gronkowski, Gordon, 1959– —Family. 2. Athletes—United States—Biography. 3. Football players—United States—Biography. 4. Fathers and sons—United States—Biography. 5. Gronkowski, Chris, 1986– 6. Gronkowski, Dan, 1985– 7. Gronkowski, Rob, 1989– I. Schober, Jeff . II. Title.<br/>
GV697.A1G73 2013<br/>
796.092'273—dc23<br/>
[B]<br/>
2013019374</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-544-12635-0<br/>
v3.0814</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?5515b63c